// src/pages/MyWSJ.js
import React from "react";
import { Link } from "react-router-dom";

function MyWSJ() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>MyWSJ</h2>
      {/* My Queue card */}
      <div style={{ border: "1px solid #ccc", padding: "10px", marginTop: "10px" }}>
        <h3>My Queue</h3>
        <p>Articles you saved</p>
        <Link to="/myqueue">Go to My Queue</Link>
      </div>
    </div>
  );
}

export default MyWSJ;